import api from "./api.js";
import i18n from "../i18n";

const assertNonEmptyBlob = (blob) => {
  if (!blob || blob.size === 0) {
    throw new Error("Received empty or invalid PDF data");
  }
};

const downloadBlobAsPdf = (blobData, filename) => {
  const blob = new Blob([blobData], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

class InvoiceService {
  async #downloadPdf(url, filename) {
    try {
      const response = await api.get(url, {
        responseType: "blob",
        headers: {
          "Accept-Language": i18n.language || "ro",
        },
      });

      assertNonEmptyBlob(response.data);
      downloadBlobAsPdf(response.data, filename);

      return { success: true };
    } catch (error) {
      throw new Error(`Failed to download invoice: ${error.message}`);
    }
  }

  async downloadInvoice(clientEmail, historyId) {
    return this.#downloadPdf(
      `/invoices/download/${clientEmail}/${historyId}`,
      `invoice-${historyId}.pdf`
    );
  }

  async downloadDomainInvoice(clientEmail, paymentId) {
    return this.#downloadPdf(
      `/invoices/domain/download/${clientEmail}/${paymentId}`,
      `domain-invoice-${paymentId}.pdf`
    );
  }
}

const invoiceService = new InvoiceService();

export default invoiceService;
